// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { intlFormat as fn } from "../intlFormat.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const intlFormat = convertToFP(fn, 3);

// Fallback for modularized imports:
export default intlFormat;
